import React, { Component } from 'react';

export default class Video extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videoState: 'pause',
            touchState: ''
        };

        this.isOnTouch = false;
    }

    componentDidMount() {
      const { videoElement } = this.refs;
      videoElement.addEventListener('ended', () => {
        this.setState({videoState: 'play'});
      });
    }

    handleTouch() {
      const element = this.refs.videoWrapper;
      if (element && this.isOnTouch === false) {
        this.setState({ touchState: 'on-mouse-enter' });
        this.isOnTouch = true;

        setTimeout(() => {
          this.setState({ touchState: '' });
          this.isOnTouch = false;
        }, 3500);
      }
    }

    videoControl() {
        const { videoElement } = this.refs;
        if (videoElement.paused) {
            videoElement.play();
            this.setState({ videoState: 'pause' });
        } else {
            videoElement.pause();
          this.setState({ videoState: 'play' });
        }
    }

    render() {
        const { videoState, touchState } = this.state;
        const { wrapperClass, source, thumbnail } = this.props;

        return(
            <div className={`kv-video ${wrapperClass} ${videoState} ${touchState}`}
                 ref="videoWrapper" onMouseMove={() => this.handleTouch()} onClick={() => this.handleTouch()}>
                <video ref="videoElement" className="video-element" preload='' autoPlay loop poster={thumbnail} >
                    <source src={source} type="video/mp4" />
                </video>
                <div className="kv-video-overlay">
                  <span className={ `kv-video-action ${videoState}` } onClick={() => this.videoControl()}></span>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Video/index.js